// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___1-IGy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/ContainerNoProps/Editor/Editor.scss
// module id = 981
// module chunks = 0